// extracted by mini-css-extract-plugin
export default {"paging":"paging_paging__rU0kh"};